<!--
 - Author : wanghongling.
 - Date   : 2019/5/28.
 - File   : yuJSafe.安全预警
 -->

<template>
  <div class="yuj-safe">
    <layer title="安全预警" width="410px">
      <div class="safe">
        <div class="safe-left">
<!--          <liquid-fill id="safeFill" :liquid-list="safeFillData"></liquid-fill>-->
          <custom-dashboard id="customDashboard" :dashboardObj="safeDashboardObj"></custom-dashboard>
        </div>
        <el-carousel :interval="10000" style="width: 300px"
            :indicator-position="resList.length>1?'outside':'none'"
            :arrow="resList.length>1?'hover':'never'">
          <el-carousel-item v-for="(item, index) in resList" :key="index">
            <ul class="safe-right" v-if="resList&&resList.length>0">
              <li
                  :class="['safe-right-item',item.length<4?'safe-right-item1':'']"
                  v-for="(shi, index) in item" :key="index"
                  @click="turnTo('Shitang',shi)">
                <p :class="['number', shi.exceptionCount>0?'yellow':'green']">
                  <countTo :startVal="0" :endVal="shi.exceptionCount" separator="" :duration="6000">
                    {{shi.exceptionCount || 0}}
                  </countTo>
                </p>
                <p class="dept-name">{{shi.departmentName}}</p>
              </li>
            </ul>
          </el-carousel-item>
          <div class="no-the-data h200" v-if="resList && resList.length===0">
            <div>
              <i class="iconfont icon-suoyourenyuan dzi"></i>
              <p>暂无食堂</p>
            </div>
          </div>
        </el-carousel>
      </div>
    </layer>
  </div>
</template>

<script>
  import customDashboard from "../echarts/customDashboard";
  export default {
    name: 'yuJSafe',
    components: { customDashboard },
    data () {
      return {
        orgId: '',
        // safeFillData: {
        //   date: 0,
        //   width: '200px',
        //   height: '200px',
        //   text: '优',
        //   value: 80
        // },
        safeDashboardObj: {
          width: '200px',
          height: '200px',
          text: '优',
          value: 0
        },
        resList: []
      }
    },
    props: {
      selectOrgId: {}
    },
    watch: {
      selectOrgId: {
        handler(cur) {
          this.orgId = cur
          this.getExceptionCountList()
          // this.getTodayTypeHandleInfo()
          this.getSafetyIndex()
        },
        deep: true
      }
    },
    mounted () {
      this.orgId = this.$store.getters.userInfo.orgId
      this.onWebsocketMsg()
      this.getExceptionCountList()
      // this.getTodayTypeHandleInfo()
      this.getSafetyIndex()
    },
    methods: {
      /**
       * @author wanghongling
       * @param name
       * @param item
       * @createTime 2019/06/19
       * @description 页面跳转
       */
      turnTo (name, item) {
        this.$emit('turnTo', name, item.departmentId, item.departmentName, item.exceptionCount)
      },
      /**
       * @author wanghongling
       * @createTime 2019/06/19
       * @description 获取各食堂异常总数 2.0以前版本
       */
      getExceptionCountList () {
        this.$request.exceptionCountListGet({orgId: this.orgId}).then(response => {
          console.log('获取各食堂异常总数2222', response)
          if (!this.$utils.isEmptyObject(response)) {
            this.resList = []
            let tmpList = response
            for (let i = 0; i < tmpList.length; i += 8) {
              this.resList.push(tmpList.slice(i, i + 8))
            }
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * @author wanghongling
       * @createTime 2019/06/19
       * @description websocket监听数据
       */
      onWebsocketMsg () {
        window.getYuJSafe = () => {
          this.getExceptionCountList()
          // this.getTodayTypeHandleInfo()
          this.getSafetyIndex()
        }
      },
      /**
       * @quthor whl
       * @createTime 2019/09/12
       * @description 获取系统安全等级
       */
      // getTodayTypeHandleInfo () {
      //   this.safeFillData.date = 0
      //   this.$request.exceptionTodayTypeHandleInfoGet({orgId: this.orgId}).then(res => {
      //     console.log('获取系统安全等级', res)
      //     res.map(v => {
      //       this.safeFillData.date = v.lightCount > this.safeFillData.date ? v.lightCount : this.safeFillData.date
      //     })
      //   }).catch(e => {
      //     console.error(e)
      //   })
      // },
      /**
       * @description: 获取异常安全指数
       * @author: linwen linwen@fjxhx.com
       * @createDate: 2021-01-19 16:31
      */
      getSafetyIndex() {
        this.$request.exceptionSafetyindexScreenAppGet({orgId: this.orgId}).then(res => {
          console.log('__安全预警__获取异常安全指数__获取异常安全指数__:', res);
          if (!this.$utils.isEmptyObject(res)) {
            this.safeDashboardObj.text = res.safetyIndex
            this.safeDashboardObj.value = res.score
          }
        })
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  @import '../../assets/less/color';

  .yuj-safe {
    padding-bottom: 15px;
    .green {
      color: @green;
    }

    .yellow {
      color: @yellow;
    }

    .safe {
      display: flex;
      margin-bottom: -10px;
      align-items: center;
      min-height: 215px;
      max-height: 240px;
      justify-content: center;

      &-left {
      }
      .el-carousel__container{
        height: 220px;
        padding-bottom: 20px;
      }

      .el-carousel__indicators--outside {
        margin-top: -20px;
      }

      .el-carousel__button {
        width: 8px;
        height: 8px;
        border-radius: 50%;
      }
      .el-carousel__indicators--outside button{
        background-color: #000;
        opacity: 1;
      }
      .el-carousel__indicator.is-active button{
        background-color: #0a8b9c;
      }
      .el-carousel__indicator--horizontal{
        padding: 6px 4px;
      }
      .el-carousel__arrow--left {
        left: 0;
      }
      .el-carousel__arrow--rgiht {
        right: 0;
      }

      &-right {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        color: #00fffc;
        align-content: center;
        height: 100%;

        &-item {
          width: 50%;
          text-align: center;
          padding: 0 0 8px;
          font-size: 14px;
          cursor: pointer;

          .number {
            font-weight: bold;
            font-size: 20px;
          }
          .dept-name{
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }
        }
        &-item1{
          width: 100%;
        }

        &-item:hover {
          background-color: rgba(0, 0, 0, .3);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/yuJSafe.vue